import { HStack, Icon, Image, Text, VStack } from "@chakra-ui/react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import linkIcon from "../assets/reviewIcons/link.svg";
import type { CreativeIdentityDetailDisplayData } from "../utils/buildCreativeIdentityReviewRows";

const DETAIL_IDENTITY_ICON_SIZE = 4;

type IdentityChipProps = {
  icon: "instagram" | "facebook" | "link";
  label: string;
};

function IdentityChip({ icon, label }: IdentityChipProps) {
  return (
    <HStack minW={0} gap={1} align="center" w="full">
      {icon === "link" ? (
        <Image
          src={linkIcon}
          alt=""
          boxSize={DETAIL_IDENTITY_ICON_SIZE}
          flexShrink={0}
        />
      ) : (
        <Icon
          as={icon === "instagram" ? FaInstagram : FaFacebookF}
          boxSize={DETAIL_IDENTITY_ICON_SIZE}
          color="gray.600"
          flexShrink={0}
          borderRadius={icon === "facebook" ? "full" : undefined}
        />
      )}
      <Text
        fontSize="xs"
        fontWeight="500"
        color="gray.600"
        fontFamily="Work Sans"
        lineHeight="130%"
        noOfLines={1}
      >
        {label}
      </Text>
    </HStack>
  );
}

type IdentityColumnProps = {
  account?: string | null;
  partner?: string | null;
  platform: "instagram" | "facebook";
};

function IdentityColumn({ account, partner, platform }: IdentityColumnProps) {
  if (!account && !partner) {
    return null;
  }

  return (
    <VStack flex={1} minW={0} align="stretch" spacing={1.5}>
      {account ? (
        <IdentityChip icon={platform} label={account} />
      ) : null}
      {partner ? <IdentityChip icon="link" label={partner} /> : null}
    </VStack>
  );
}

export default function CreativeIdentityDetailDisplay({
  instagramAccount,
  facebookAccount,
  instagramPartner,
  facebookPartner,
}: CreativeIdentityDetailDisplayData) {
  const showInstagram = Boolean(instagramAccount || instagramPartner);
  const showFacebook = Boolean(facebookAccount || facebookPartner);

  if (!showInstagram && !showFacebook) {
    return null;
  }

  return (
    <HStack gap={3} align="flex-start" w="full">
      {showInstagram ? (
        <IdentityColumn
          platform="instagram"
          account={instagramAccount}
          partner={instagramPartner}
        />
      ) : null}
      {showFacebook ? (
        <IdentityColumn
          platform="facebook"
          account={facebookAccount}
          partner={facebookPartner}
        />
      ) : null}
    </HStack>
  );
}
